// extracted by mini-css-extract-plugin
module.exports = {"PlainFeature":"kc_a"};